exports = module.exports = require("./../../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vw-card{background:#fff;border-radius:5px;overflow:hidden}.vw-card-head,.vw-card-links .card-link-wrapper{border-bottom:1px solid #d9d9d9}.vw-card-head:last-child,.vw-card-links .card-link-wrapper:last-child{border:none}", "", {"version":3,"sources":["/./src/components/cards/card.vue"],"names":[],"mappings":"AACA,SAAS,gBAAgB,kBAAkB,eAAe,CACzD,AACD,gDAAgD,+BAA+B,CAC9E,AACD,sEAAsE,WAAW,CAChF","file":"card.vue","sourcesContent":["\n.vw-card{background:#fff;border-radius:5px;overflow:hidden\n}\n.vw-card-head,.vw-card-links .card-link-wrapper{border-bottom:1px solid #d9d9d9\n}\n.vw-card-head:last-child,.vw-card-links .card-link-wrapper:last-child{border:none\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?sourceMap!./~/.10.0.2@vue-loader/lib/style-rewriter.js?id=data-v-901cbf9e!./~/.2.2.3@less-loader?sourceMap!./~/.10.0.2@vue-loader/lib/selector.js?type=styles&index=0!./src/components/cards/card.vue
// module id = 101
// module chunks = 0